import React, { useCallback, useEffect, useState } from "react";
import type { RcFile, UploadFile, UploadProps } from "antd/es/upload/interface";
import { Form, Image, Progress, Upload, message } from "antd";
import { Rule } from "antd/lib/form";
import FileApi from "common/api/FileApi";
import FileModel from "common/models/FileModel";
import { useAppSelector } from "app/hooks";
import { selectToken, selectUser } from "features/auth/AuthSlice";
import { FileJson, Upload as UploadFileAntd } from "common/types/File";
import FileUploadItem2 from "./FileUploadItem2";
import FileCollection from "common/collections/FileCollection";

type Props = {
  formName: string;
  rules?: Rule[] | undefined;
  onDeleteCompleted?: (f: FileModel) => void;
  onUploadCompleted?: (fs: FileModel[], type: "add" | "delete") => void;
  initFiles?: UploadFileAntd[] | undefined;
};

const ButtonUpload2 = ({
  formName = "image",
  rules,
  onDeleteCompleted,
  onUploadCompleted,
  initFiles,
}: Props) => {
  const [messageApi, contextHolder] = message.useMessage();

  const [fileList, setFileList] = useState<UploadFile[]>(initFiles || []);
  const [files, setFiles] = useState(initFiles || []);
  //
  const token = useAppSelector(selectToken);
  const user = useAppSelector(selectUser);
  //

  const uploadPropsFileApi = new FileApi(false).getUploadProps({
    directory_id: 0,
    object_type: FileModel.OBJECTTYPE_SIMPLE(),
    object_id: 0,
    origin: "image",
    user_id: user?.user.id,
    token: token,
  });

  const normFile = (e: any) => {
    if (Array.isArray(e)) {
      return e;
    }
    return e && e.fileList;
  };

  // function
  const onChange: UploadProps["onChange"] = ({
    fileList: newFileList,
    file,
    event,
  }) => {
    setFiles(fileList.map((f) => (f.status === "error" ? { ...f } : f)));
    //append uploaded file to list
    if (
      // newFileList.every(
      //   (i) =>
      //     i.status === "done" && i.response === "object" && i.response.id > 0
      // ) === true
      file?.status === "done" &&
      typeof file?.response === "object" &&
      file?.response?.id > 0 &&
      typeof onUploadCompleted === "function"
    ) {
      setFileList(newFileList);
      const newFile = newFileList
        .filter(
          (f) =>
            typeof f.response === "object" &&
            !f.response.hasOwnProperty("error")
        )
        .map((f) => {
          return new FileModel(f.response as FileJson);
        });
      if (newFileList.some((f) => f.status === "done")) {
        onUploadCompleted &&
          onUploadCompleted(
            newFile.filter((f) => f.id !== 0),
            "add"
          );
      }
    } else {
    }
  };

  const handleDeleteFileList = (uid: string) => {
    const newFileList = fileList.filter((i) => i.uid !== uid);
    const newFile = newFileList
      .filter((f) => typeof f.response === "object")
      .map((f) => {
        return new FileModel(f.response as FileJson);
      });
    setFileList((prev) => newFileList);
    onUploadCompleted && onUploadCompleted(newFile, "delete");
  };

  const handleDeleteFileDone = ({
    error,
    res,
  }: {
    error: string;
    res: string;
  }) => {
    // error.length > 0 &&
    //   messageApi.open({
    //     content: "Có lỗi không thể xóa hình",
    //     type: "error",
    //   });

    messageApi.open({
      content: "Xóa hình thành công",
      type: "success",
    });
  };

  const handleBeforeUpload = (file: any) => {
    const maxFiles = 5; // Số lượng tối đa của hình ảnh
    if (fileList.length >= maxFiles) {
      message.error(`Bạn chỉ có thể tải lên tối đa ${maxFiles} hình ảnh.`);
      return false; // Không cho phép tải lên nếu vượt quá số lượng tối đa
    }
    return true; // Cho phép tải lên nếu chưa vượt quá số lượng tối đa
  };

  // const onPreview = async (file: UploadFile) => {
  //   let src = file.url as string;
  //   if (!src) {
  //     src = await new Promise((resolve) => {
  //       const reader = new FileReader();
  //       reader.readAsDataURL(file.originFileObj as RcFile);
  //       reader.onload = () => resolve(reader.result as string);
  //     });
  //   }
  //   const image = new Image() as any;
  //   image.src = src;
  //   const imgWindow = window.open(src);
  //   imgWindow?.document.write(image.outerHTML);
  // };
  useEffect(() => {
    if (initFiles) {
      setFileList(initFiles);
    }
  }, [initFiles]);
  return (
    <div id="upload-wrapper">
      {contextHolder}
      <Form.Item
        name={formName}
        valuePropName="fileList"
        getValueFromEvent={normFile}
        noStyle
        rules={rules}
      >
        {/* <ImgCrop rotationSlider zoomSlider maxZoom={5} quality={3}> */}
        <Upload
          name={formName}
          {...uploadPropsFileApi}
          listType="picture-card"
          fileList={fileList}
          onChange={onChange}
          accept=".jpg,.png,.jpeg"
          multiple={true}
          maxCount={5}
          // onPreview={onPreview}
          beforeUpload={handleBeforeUpload}
          itemRender={(_originNode, file, _fileList, actions) => {
            //we extract file from state, not directory from `file` object,
            //because on error, the file.response in state will contain string, this is correct
            const foundFile = files.find((f) => f.uid === file.uid);
            return (
              <FileUploadItem2
                file={file}
                handleDeleteFileList={(uid) => {
                  handleDeleteFileList(uid);
                }}
                handleDeleteFileDone={({ error, res }) => {
                  handleDeleteFileDone({ error: error, res: res });
                  setTimeout(() => {
                    actions.remove();
                  }, 500);
                }}
              ></FileUploadItem2>
            );
          }}
        >
          {fileList.filter((img) => img.response?.status !== "error").length <
            5 && "+ Upload"}
        </Upload>
      </Form.Item>
    </div>
  );
};

export default ButtonUpload2;
